<template>
    <crud-create
        :open="open"
        :loading="loading"
        title="Nuevo Vendedor"
        :errorMessage="errorMessage"
        @create="create"
        @close="$emit('close')"
    >
        <vendedor-form ref="form" v-model="form" :input-errors="inputErrors" />
    </crud-create>
</template>

<script>
import VendedorProvider from "../../../providers/VendedorProvider";
import { CrudCreate } from "@dracul/common-frontend";
import ClientError from "@/errors/ClientError";
import VendedorForm from "../VendedorForm/VendedorForm.vue";

export default {
    name: "VendedorCreate",
    components: { VendedorForm, CrudCreate },
    props: {
        open: { type: Boolean, default: true },
    },
    data() {
        return {
            errorMessage: "",
            inputErrors: {},
            loading: false,
            form: {
                nombre: null,
                apellido: null,
                email: null,
                telefono: null,
                comision: 0,
                activo: true,
            },
        };
    },
    methods: {
        create() {
            if (this.$refs.form.validate()) {
                this.loading = true;
                VendedorProvider.createVendedor(this.form)
                    .then((r) => {
                        if (r) {
                            this.$emit("itemCreated", r.data.vendedorCreate);
                            this.$emit("close");
                        }
                    })
                    .catch((error) => {
                        let clientError = new ClientError(error);
                        this.inputErrors = clientError.inputErrors;
                        this.errorMessage = clientError.i18nMessage;
                    })
                    .finally(() => (this.loading = false));
            }
        },
    },
};
</script>
